import {
    Component, Mixins,
} from 'vue-property-decorator';
import CoreMixin from '@nodes/mixins/Core';
import { YPanel, YForm } from '@components/index';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Props from './props';

@Component({
    components: {
        YPanel,
        YForm,
    },
})

/**
 * @name ProfileChangePassword
 */
export default class ProfileChangePassword extends Mixins(CoreMixin, HybridMixin, Props) {
    model = {};
    showChangePasswordForm = true;
    formElementsArray: Array<{[k: string]: any}> = [];

    /**
     * @inheritdoc
     */
    created() {
        this.fetchFormConfig();
    }

    /**
     * Fetch Password form config
     * 
     * @returns {*}
     */
    fetchFormConfig(): any {
        this.$wait.start('fetch-password-form');
        return this.$services[this.formService.name][this.formService.api]().then((response) => {
            this.formElementsArray = response.data.metadata.form;
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('fetch-password-form');
        });
    }

    /**
     * Change Password Request
     * 
     * @returns {*}
     */
    changePassword(): any {
        this.$wait.start('change-password');
        return this.$services[this.changePasswordService.name][this.changePasswordService.api](this.model).then(() => {
            this.model = {};
            this.$toast.success(this.successMessage || this.$t('messages.success.change_password'));
            this.showChangePasswordForm = false;
            setTimeout(() => {
                this.showChangePasswordForm = true;
            }, 100);
            // TODO i don't know what is this :(
            // this.$store.commit('auth/setForcePasswordChange', false);
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('change-password');
        });
    }
}
